export default (response) => response.items[0];
